// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var container = "ListPagination-module--container--12AT8";
export var button = "ListPagination-module--button--1fTg1";
export var disabled = "ListPagination-module--disabled--2BVlf";
export var label = "ListPagination-module--label--3Ik45";
export var iconLeft = "ListPagination-module--iconLeft--2kpl2";
export var iconRight = "ListPagination-module--iconRight--3HkIG";
export var numbers = "ListPagination-module--numbers--1zrlL";
export var pageNumber = "ListPagination-module--pageNumber--1ucYy";
export var ellipsis = "ListPagination-module--ellipsis--Cwn8M";
export var selected = "ListPagination-module--selected--1S592";